/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ComputerIcon
 */
export default class ComputerIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M20 3a3 3 0 013 3v9a3 3 0 01-3 3h-5.25c0 .18.048.36.144.553.283.564.719 1.145 1.313 1.74.63.63.184 1.707-.707 1.707h-7c-.89 0-1.337-1.077-.707-1.707.594-.595 1.03-1.176 1.313-1.74.096-.192.144-.372.144-.552L4 18a3 3 0 01-3-3V6a3 3 0 013-3h16zm-7.25 15l-1.5.001c0 .486-.119.972-.356 1.446-.092.185-.195.37-.309.553h2.83a7.019 7.019 0 01-.31-.553A3.217 3.217 0 0112.75 18zM20 5H4a1 1 0 00-1 1v9a1 1 0 001 1h16a1 1 0 001-1V6a1 1 0 00-1-1z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

